import tippy from 'tippy.js';
import { delegate } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import './tooltips.css';

class tippyJs {
    init() {
        tippy('[data-tippy-content]', {
            maxWidth: 500,
        });

        delegate('#chop-service-calculator', {
            target: '[data-tippy-content]'
        });

        delegate('#BasketArea', {
            target: '[data-tippy-content]'
        });
    }
}
export default tippyJs;